import type { FC } from 'react';

import type { TypeSelectionStepProps } from '@/sections/seeds/components/modals/AddSeedByTypeModal/AddSeedByTypeModal.types';
import { SeedTypeSelector } from '@/sections/seeds/components/modals/AddSeedByTypeModal/SeedTypeSelector';
import { SeedTypeOption } from '@/types';

/**
 * Step 1: Type Selection
 *
 * Renders the seed type selector (Network Assets, Web Applications, Web Services)
 * and displays any subscription errors.
 */
export const TypeSelectionStep: FC<TypeSelectionStepProps> = ({
  formData,
  setFormData,
  subscriptionError,
}) => {
  const handleTypeChange = (type: SeedTypeOption) => {
    setFormData(prev => ({ ...prev, seedType: type }));
  };

  return (
    <>
      <SeedTypeSelector value={formData.seedType} onChange={handleTypeChange} />
      {subscriptionError && (
        <div className="border-chariot-stroke-critical bg-chariot-stroke-critical/10 rounded-md border p-3">
          <div className="text-chariot-stroke-critical text-sm">
            {subscriptionError}
          </div>
        </div>
      )}
    </>
  );
};
